import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { marketplaceaccountApi, type AccountDashboard } from '../../api/marketplaceaccount';

const NAV = [
  { to: '/marketplace-accounts/wizard', label: 'Connection wizard' },
  { to: '/marketplace-accounts/connections', label: 'Connections' },
  { to: '/marketplace-accounts/credentials', label: 'Credential manager' },
  { to: '/marketplace-accounts/health', label: 'Health dashboard' },
  { to: '/marketplace-accounts/settings', label: 'Channel settings' },
  { to: '/marketplace-accounts/mappings', label: 'Mappings' },
];

export function MarketplaceAccountHubPage() {
  const [dashboard, setDashboard] = useState<AccountDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void marketplaceaccountApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total accounts', value: dashboard.total_accounts },
        { label: 'Active', value: dashboard.active_accounts },
        { label: 'Healthy', value: dashboard.healthy_accounts },
        { label: 'Expiring tokens', value: dashboard.expiring_tokens },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Marketplace Accounts</h1>
      <p className="mt-1 text-sm text-slate-600">OAuth, credentials, and channel configuration for all marketplaces.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
      {dashboard?.by_marketplace && (
        <div className="mt-8">
          <h2 className="text-lg font-medium">By marketplace</h2>
          <ul className="mt-2 space-y-1 text-sm">
            {Object.entries(dashboard.by_marketplace).map(([k, v]) => (
              <li key={k}>{k}: {v}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
